const Mutations = Object.freeze({
	SET_SELECTEDWORKBOOK: 'reportsModule/reportWorkbook/SET_SELECTEDWORKBOOK',
});

export const Actions = Object.freeze({
	CLEAR: 'reportsModule/reportWorkbook/CLEAR',
	LOAD_WORKBOOK: 'reportsModule/reportWorkbook/LOAD_WORKBOOK',
	LOAD_REPORT_DATA: 'reportsModule/reportWorkbook/LOAD_REPORT_DATA',
	EXPORT: 'reportsModule/reportWorkbook/EXPORT',
});

export const Getters = Object.freeze({
	SELECTED_WORKBOOK: 'reportsModule/reportWorkbook/SELECTED_WORKBOOK',
});

import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/reportBuilderService';
import exportDataService from '../../../../../services/data/dataExportService';
import fileUtils from '../../../../../utils/fileUtils';

export default {
	state: {
		selectedWorkbook: null,
	},
	mutations: {
		[Mutations.SET_SELECTEDWORKBOOK](state, item) {
			state.selectedWorkbook = item;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_SELECTEDWORKBOOK, null);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},
		[Actions.LOAD_WORKBOOK]({ commit, dispatch }, workbookId) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getWorkbook(workbookId)
					.then((resp) => {
						commit(Mutations.SET_SELECTEDWORKBOOK, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.LOAD_REPORT_DATA]({ dispatch }, payload) {
			return new Promise((resolve, reject) => {
				//dataService.loadReportPreviewData(payload).then(resp => {
				dataService
					.reportPreview(payload)
					.then((resp) => {
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						reject(error);
					});
			});
		},
		[Actions.EXPORT]({ dispatch }, payload) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				exportDataService
					.downloadWorkbookPreviewDirect(payload.payload)
					.then((resp) => {
						const fileInfo =
							fileUtils.extractFileInfoFromResponse(resp);
						const filename = fileInfo.filename;

						const blob = new Blob([resp.data], {
							type: fileInfo.mimeType,
						});
						const url = window.URL.createObjectURL(blob);
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', filename);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						window.URL.revokeObjectURL(url);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},
	getters: {
		[Getters.SELECTED_WORKBOOK]: (state) => {
			if (!state.selectedWorkbook) return null;
			return JSON.parse(JSON.stringify(state.selectedWorkbook));
		},
	},
};
